import { memo } from "react";
import { ChartCardProps } from "../Interfaces";
import PeopleQueueChartContainer from "./Container";

const PeopleQueueChart = (props: ChartCardProps) => {
  return <PeopleQueueChartContainer {...props} />;
};

export default memo(PeopleQueueChart);
